/**
 * @prettier
 */
import React from "react"
import SwaggerUILogo from "../assets/logo_small.svg"

const Logo = () => <SwaggerUILogo height="40" />

export default Logo
